package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsCapNotice
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.components.OpsUntrustedText
import dev.lingvo.ops.state.OpsWebhookRisk
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.ops.state.webhookRisk
import dev.lingvo.ops.state.webhookRiskOrder
import dev.lingvo.shared.ops.OpsWebhookRowDto
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.ds.LTable
import dev.lingvo.site.ds.LTableBody
import dev.lingvo.site.ds.LTableCell
import dev.lingvo.site.ds.LTableHead
import dev.lingvo.site.ds.LTableHeaderCell
import dev.lingvo.site.ds.LTableRow
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.formatUtc
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Page("/webhooks")
@Composable
fun WebhooksPage() {
    OpsShell("Webhooks") {
        val resource = rememberOpsResource(Unit) { OpsApi.webhookHealth() }

        Column(Modifier.width(100.percent).gap(Space.XL)) {
            OpsPageHeader("Webhooks", "Inspect endpoint health and recent delivery failures without opening customer URLs.", resource.state.isRefreshing, resource::refresh)
            OpsResourceStates(resource.state, "No webhooks", "This workspace set has no webhook records.", retry = resource::refresh) { value ->
                OpsPanel("Risk-ordered endpoints", "Every customer URL is plain text. There is no open or copy-as-link action.") { OpsCapNotice(value.hitCap, value.cappedAt, "webhooks"); WebhookTable(webhookRiskOrder(value.rows)) }
            }
        }
    }
}

@Composable
private fun WebhookTable(rows: List<OpsWebhookRowDto>) {
    LTable(caption = "Webhooks") {
        LTableHead { LTableRow { LTableHeaderCell { Text("URL") }; LTableHeaderCell { Text("Open") }; LTableHeaderCell { Text("Workspace") }; LTableHeaderCell { Text("Risk") }; LTableHeaderCell { Text("Last attempt") }; LTableHeaderCell { Text("Status") } } }
        LTableBody { rows.forEach { row -> LTableRow {
            LTableCell { OpsUntrustedText(row.url) }
            LTableCell { WebhookLink(row.webhookId) }
            LTableCell { Text(row.orgName) }; LTableCell { LBadge(webhookRisk(row).name, variant = riskVariant(webhookRisk(row))) }; LTableCell { Text(formatUtc(row.lastAttemptAt)) }; LTableCell { Text(row.lastStatus?.toString() ?: "—") }
        } } }
    }
}

@Composable
private fun WebhookLink(webhookId: String) {
    A(href = "/webhooks/$webhookId") { Text("Inspect") }
}

private fun riskVariant(risk: OpsWebhookRisk): LBadgeVariant = when (risk) {
    OpsWebhookRisk.FAILING -> LBadgeVariant.DANGER
    OpsWebhookRisk.UNSIGNED -> LBadgeVariant.WARNING
    OpsWebhookRisk.QUIET -> LBadgeVariant.INFO
    OpsWebhookRisk.HEALTHY -> LBadgeVariant.SUCCESS
}
